module.exports = __webpack_public_path__ + "static/media/accordion-triangle.0fa500bf.svg";